const SET_MASTERDATA = 'SET_MASTERDATA';

interface MasterDataState {
  isFetchedSettings: boolean;
}

const defaultState: MasterDataState = {
  isFetchedSettings: false,
};

interface SetMasterDataAction {
  type: typeof SET_MASTERDATA;
  payload: {
    isFetchedSettings: boolean;
  };
}

type MasterDataActions = SetMasterDataAction;

function masterdataReducer(
  state = defaultState,
  action: MasterDataActions,
): MasterDataState {
  switch (action.type) {
    case SET_MASTERDATA:
      return {
        ...state,
        isFetchedSettings: action.payload.isFetchedSettings,
      };
    default:
      return state;
  }
}

export default masterdataReducer;

export const setMasterData = (isFetchedSettings: boolean): SetMasterDataAction => ({
  type: SET_MASTERDATA,
  payload: { isFetchedSettings },
});